import { Suspense } from 'react';
import { AuthProvider } from '../../context/AuthContext';
import { ToastProvider } from '../../context/ToastContext';
import PageLoader from '../../components/loaders/PageLoader';

export default function AppProviders({ children }) {
  return (
    <AuthProvider>
      <ToastProvider>
        <Suspense fallback={<PageLoader />}>
          {children}
        </Suspense>
      </ToastProvider>
    </AuthProvider>
  );
}
